export default __webpack_public_path__ + "static/media/maeoil2.31e3af6b.png";